import { Result } from 'Feature/Arrears/components/ArrearsInquiryPage/core/Result';
import { ManualChange } from 'Feature/Arrears/components/ArrearsErrorRecord/ManualChanges/core/ManualChange';
import { AuthenticationContextType } from 'Foundation/Authentication';
import { ApiClient } from 'Foundation/Api';
import { ApiSuccessResponse } from 'Feature/Arrears/components/ArrearsInquiryPage/api/ApiResponse';

export interface ArrearsFileManualChangesApi {
  get: (arrearsFileId: string) => Promise<Result<ManualChange[], string>>;
}

export const arrearsFileManualChangesApi = (
  auth: AuthenticationContextType,
  baseUrl: string
): ArrearsFileManualChangesApi => {
  const { getWithAuth } = ApiClient(auth, { timeout: 10000 });

  const get = async (arrearsFileId: string) => {
    try {
      const url = `${baseUrl}/${arrearsFileId}/manual-changes`;
      const response = await getWithAuth(url);
      const apiResponse = response.data as ApiSuccessResponse<ManualChange[]>;
      return Result.success(apiResponse.data);
    } catch (error) {
      const apiError = error as any;
      return Result.failure(apiError.response?.data?.error?.errorCode ?? 'unknown-error');
    }
  };

  return { get };
};
